module.exports = __webpack_public_path__ + "static/media/chevronLeft.f56cae10.svg";